'use strict';

var React = require('react');
var Text$1 = require('@swiggy-private/dls-web-core/dist/components/Text');
var index_es = require('./index.es-8c72aff8.js');
var GridWidgetLayout = require('./GridWidgetLayout-45f68042.js');
var WidgetController_widgets_GridWidgetLayout_type = require('./WidgetController/widgets/GridWidgetLayout/type.js');
var Text = require('./Text-fd66b8ee.js');
var styled = require('styled-components');
var ImageInfoLayoutCard = require('./ImageInfoLayoutCard-1f4bac4a.js');
var RestaurantRenderer = require('./RestaurantRenderer-b1b439d1.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const TextFlexContainer = styled__default['default'].div({
    display: "flex",
    alignItems: "center",
});
const TextContainer = styled__default['default'].div({
    scrollSnapAlign: "center",
    flexShrink: 0,
    whiteSpace: "pre",
});

const getTextWidgets = ({ cards }) => {
    return [
        React__default['default'].createElement(TextFlexContainer, null, cards === null || cards === void 0 ? void 0 : cards.map((card, index) => (React__default['default'].createElement(TextContainer, { key: index },
            React__default['default'].createElement(Text.Text, Object.assign({}, card, { key: card.text, attrs: card.attrs })))))),
    ];
};

const getInlineTextWidgets = ({ cards }) => {
    return [
        React__default['default'].createElement(React__default['default'].Fragment, null, cards === null || cards === void 0 ? void 0 : cards.map((card, index) => (React__default['default'].createElement(Text.Text, Object.assign({ key: index }, card))))),
    ];
};

const transformLayout = (layout) => {
    const { rows, columns, horizontalScrollEnabled, itemSpacing, lineSpacing, containerStyle, customStyle, scrollBar, widgetPadding, } = layout;
    return {
        rows,
        columns,
        horizontalScrollEnabled,
        itemSpacing: itemSpacing || 0,
        lineSpacing: lineSpacing || 0,
        widgetPadding,
        containerStyle,
        customStyle,
        scrollBar,
    };
};
const GridWidgetWrapper = ({ header, gridElements, layout, id, position, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!gridElements)
        return null;
    const gridWidgetType = (_a = gridElements.infoWithStyle) === null || _a === void 0 ? void 0 : _a["@type"];
    const layoutData = transformLayout(layout);
    let widgets;
    const { impressionAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const analyticsVal = {
        widgetPosition: Number(position) + 1,
        collectionId: (_b = gridElements.infoWithStyle) === null || _b === void 0 ? void 0 : _b.collectionId,
        theme: (_c = gridElements.infoWithStyle) === null || _c === void 0 ? void 0 : _c.theme,
        widgetId: id,
    };
    switch (gridWidgetType) {
        case WidgetController_widgets_GridWidgetLayout_type.GridWidgetTypes.TEXT_GRID: {
            widgets = getTextWidgets({
                cards: ((_d = gridElements.infoWithStyle) === null || _d === void 0 ? void 0 : _d.cards) || [],
            });
            break;
        }
        case WidgetController_widgets_GridWidgetLayout_type.GridWidgetTypes.INLINE_TEXT: {
            widgets = getInlineTextWidgets({
                cards: ((_e = gridElements.infoWithStyle) === null || _e === void 0 ? void 0 : _e.cards) || [],
            });
            break;
        }
        case WidgetController_widgets_GridWidgetLayout_type.GridWidgetTypes.IMAGE_INFO_LAYOUT_CARD: {
            if (!index_es.N(impressionAnalytics)) {
                impressionAnalytics({
                    action: "impression-image-card",
                    value: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    label: id,
                    context: {
                        widgetId: id,
                        widget_vpos: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    },
                });
            }
            widgets = ImageInfoLayoutCard.getImageInfoLayoutCards(gridElements.infoWithStyle, index_es.X(layout.containerStyle, "containerPadding"), analyticsVal);
            break;
        }
        case WidgetController_widgets_GridWidgetLayout_type.GridWidgetTypes.RESTAURANT_CARD: {
            widgets = RestaurantRenderer.getRestaurantCards({
                widgetType: (_f = gridElements.infoWithStyle) === null || _f === void 0 ? void 0 : _f.widgetType,
                restaurants: (_g = gridElements.infoWithStyle) === null || _g === void 0 ? void 0 : _g.restaurants,
                analyticsVal,
                containerPadding: (_h = layoutData === null || layoutData === void 0 ? void 0 : layoutData.containerStyle) === null || _h === void 0 ? void 0 : _h.containerPadding,
            });
            break;
        }
        default:
            return null;
    }
    if (widgets)
        return (React__default['default'].createElement(GridWidgetLayout.GridWidgetLayout, { header: header, widgets: widgets, layout: layoutData, gridWidgetId: id }));
    return null;
};

const PositionRelativeDiv = styled__default['default'].div(({ margin }) => {
    var _a, _b, _c, _d;
    return ({
        position: "relative",
        top: (_a = margin === null || margin === void 0 ? void 0 : margin.top) !== null && _a !== void 0 ? _a : "auto",
        bottom: (_b = margin === null || margin === void 0 ? void 0 : margin.bottom) !== null && _b !== void 0 ? _b : "auto",
        left: (_c = margin === null || margin === void 0 ? void 0 : margin.left) !== null && _c !== void 0 ? _c : "auto",
        right: (_d = margin === null || margin === void 0 ? void 0 : margin.right) !== null && _d !== void 0 ? _d : "auto",
        width: "90%",
    });
});

const Masthead = ({ mastheadWidget }) => {
    const { widget, textDetails } = mastheadWidget;
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement(GridWidgetWrapper, Object.assign({}, widget)), textDetails === null || textDetails === void 0 ? void 0 :
        textDetails.map((textDetail) => {
            return (React__default['default'].createElement(PositionRelativeDiv, { margin: textDetail.margin, style: { width: "90%" } },
                React__default['default'].createElement(Text$1.Text, { variant: "body_B2_Reg", color: "text_inverse_Highest_Emphasis" }, textDetail.text)));
        })));
};
var Masthead$1 = React__default['default'].memo(Masthead);

exports.GridWidgetWrapper = GridWidgetWrapper;
exports.Masthead = Masthead$1;
//# sourceMappingURL=Masthead-0c037a17.js.map
